async function updateCartPageCart(lineItemKey, quantity) {
  const cartPageCheckoutValue = document.getElementById('cart-page-checkout-value');
  const cartPageCheckoutButton = document.getElementById('cart-page-checkout-button');
  cartPageCheckoutButton.classList.add('button--loading');
  cartPageCheckoutValue.classList.add('text--loading');
  response = await fetch(window.Shopify.routes.root + 'cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      updates: {
        [lineItemKey]: quantity
      },
      sections: "cart-items,cart-sidebar"
    })
  });
  const responseJson = await response.json();

  // Validate the response & prepare to update the prices
  const headerCartItemCountElement = document.querySelector('.header__cart-button-count');
  headerCartItemCountElement.innerText = responseJson.item_count;
  if (responseJson.item_count > 0) {
    headerCartItemCountElement.classList.remove('header__cart-button-count--hidden');
  } else {
    headerCartItemCountElement.classList.add('header__cart-button-count--hidden');
  }
  const cart = document.getElementById('cart');
  if (responseJson.items.length === 0) {
    cart.classList.add('cart-page--empty');
  } else {
    cart.classList.remove('cart-page--empty');
  }

  const cartItems = document.createElement('div');
  cartItems.innerHTML = responseJson.sections['cart-items'];
  document.getElementById('shopify-section-cart-items').innerHTML = cartItems.querySelector('#shopify-section-cart-items').innerHTML;

  const cartSidebar = document.createElement('div');
  cartSidebar.innerHTML = responseJson.sections['cart-sidebar'];
  document.getElementById('shopify-section-cart-sidebar').innerHTML = cartSidebar.querySelector('#shopify-section-cart-sidebar').innerHTML;

  initCartPage();
}

function initCartPagePriceButtons() {
  const pickeupPriceButtonElement = document.getElementById('cart-page-sidebar-pickup-price-button');
  if (pickeupPriceButtonElement !== null && !pickeupPriceButtonElement.classList.contains('cart-page--initialized')) {
    pickeupPriceButtonElement.addEventListener('click', () => {
      setCartPrices('pickup');
      localStorage.setItem('priceType', 'pickup');
    });
    pickeupPriceButtonElement.classList.add('cart-page--initialized');
  }

  const shippingPriceButtonElement = document.getElementById('cart-page-sidebar-shipping-price-button');
  if (shippingPriceButtonElement !== null && !shippingPriceButtonElement.classList.contains('cart-page--initialized')) {
    shippingPriceButtonElement.addEventListener('click', () => {
      setCartPrices('shipping');
      localStorage.setItem('priceType', 'shipping');
    });
    shippingPriceButtonElement.classList.add('cart-page--initialized');
  }
}


function setCartPrices(type) {
  let otherType = 'shipping';
  if (type === 'shipping') {
    otherType = 'pickup';
  }

  const activePriceButtonElement = document.getElementById('cart-page-sidebar-' + type + '-price-button');
  if (activePriceButtonElement !== null) {
    activePriceButtonElement.classList.add('cart-page__sidebar-price-button--active');
  }

  const otherPriceButtonElement = document.getElementById('cart-page-sidebar-' + otherType + '-price-button');
  if (otherPriceButtonElement !== null) {
    otherPriceButtonElement.classList.remove('cart-page__sidebar-price-button--active');
  }

  const totalPriceElement = document.getElementById('cart-page-checkout-value');
  const lineItemElements = document.querySelectorAll('.cart-page__item');
  let totalPrice = 0;
  lineItemElements.forEach((lineItemElement) => {
    const lineItemPriceElement = lineItemElement.querySelector('.cart-page__item-info-header-line-price');
    const lineItemQuantityElement = lineItemElement.querySelector('.cart-page__item-info-footer-quantity-input');
    const lineItemPriceInfoElement = lineItemElement.querySelector('.cart-page__item-info-price');
    const singlePrice = parseInt(lineItemElement.dataset[type + 'Price'])
    const lineItemPrice = parseInt(lineItemQuantityElement.value) * singlePrice;
    totalPrice += lineItemPrice;
    lineItemPriceInfoElement.innerText = lineItemPriceInfoElement.dataset.templateText.replaceAll('{price}', Layout.formatPrice(singlePrice));
    lineItemPriceElement.innerText = Layout.formatPrice(lineItemPrice);
  });
  if (totalPriceElement !== null) {
    totalPriceElement.innerText = Layout.formatPrice(totalPrice);
  }
}


function updateCartSidebarSticky() {
  const cartSidebarBottom = document.querySelector('.cart-sidebar__bottom');
  const cartSidebarSection = document.getElementById('shopify-section-cart-sidebar');
  const viewportOffset = cartSidebarBottom.getBoundingClientRect();
  const maxPadding = cartSidebarBottom.offsetHeight - cartSidebarSection.offsetHeight;
  cartSidebarBottom.style.paddingTop = Math.min(maxPadding, Math.max(0, 112 - viewportOffset.top)) + 'px';
}


function initCartPage() {
  const cartSidebar = document.querySelector('.cart-sidebar');
  const cartSidebarBottom = document.querySelector('.cart-sidebar__bottom');
  const cartSidebarSection = document.getElementById('shopify-section-cart-sidebar');
  if (cartSidebar === null && cartSidebarBottom !== null && cartSidebarSection !== null) {
    window.addEventListener('scroll', updateCartSidebarSticky);
    window.addEventListener('resize', updateCartSidebarSticky);
    updateCartSidebarSticky();
  }

  const cartPage = document.querySelector('.cart-page');
  if (cartPage === null) {
    return;
  }

  if (cartSidebar !== null) {
    const cartPageCloseButton = cartSidebar.querySelector('.cart-page__title-close-button');
    if (!cartPageCloseButton.classList.contains('cart-page__title-close-button--initialized')) {
      cartPageCloseButton.classList.add('cart-page__title-close-button--initialized');
      cartPageCloseButton.addEventListener('click', () => {
        Layout.hideCartSidebar();
      });
    }
  }


  let priceType = localStorage.getItem('priceType');
  if (priceType === null) {
    priceType = 'pickup';
  }
  setCartPrices(priceType);

  initCartPagePriceButtons();

  const cartPageForm = document.getElementById('cart');
  if (!cartPageForm.classList.contains('cart-page--initialized')) {
    const cartPageCheckoutButton = document.getElementById('cart-page-checkout-button');
    cartPageForm.addEventListener('submit', () => {
      cartPageCheckoutButton.classList.add('button--loading');
    });
    cartPageForm.classList.add('cart-page--initialized');
  }

  const cartItems = document.querySelectorAll('.cart-page__item:not(.cart-page--initialized)');
  cartItems.forEach((cartItem) => {
    const toggleUp = cartItem.querySelector('.cart-page__item-info-footer-quantity-button--plus');
    const toggleDown = cartItem.querySelector('.cart-page__item-info-footer-quantity-button--minus');
    const input = cartItem.querySelector('.cart-page__item-info-footer-quantity-input');
    const removeButton = cartItem.querySelector('.cart-page__item-info-footer-delete-button');
    const linePrice = cartItem.querySelector('.cart-page__item-info-header-line-price');

    toggleUp.addEventListener('click', (event) => {
      const value = parseInt(input.value);
      let newValue = null;
      if (isNaN(value) || value < 1) {
        newValue = 1;
      } else {
        newValue = value + 1;
      }
      if (newValue !== value) {
        input.value = newValue;
        linePrice.classList.add('text--loading');
        toggleDown.classList.remove('cart-page__item-info-footer-quantity-button--disabled');
        updateCartPageCart(cartItem.dataset.lineItemKey, newValue);
      }
    });

    toggleDown.addEventListener('click', (event) => {
      const value = parseInt(input.value);
      let newValue = null;
      if (isNaN(value) || value < 2) {
        newValue = 1;
      } else {
        newValue = value - 1;
      }
      if (newValue !== value) {
        input.value = newValue;
        linePrice.classList.add('text--loading');
        if (newValue === 1) {
          toggleDown.classList.add('cart-page__item-info-footer-quantity-button--disabled');
        }
        updateCartPageCart(cartItem.dataset.lineItemKey, newValue);
      }
    });

    input.addEventListener('change', (event) => {
      let value = parseInt(event.target.value);
      if (isNaN(value) || value < 1) {
        value = 1;
        input.value = value;
      }
      linePrice.classList.add('text--loading');
      if (value === 1) {
        toggleDown.classList.add('cart-page__item-info-footer-quantity-button--disabled');
      } else {
        toggleDown.classList.remove('cart-page__item-info-footer-quantity-button--disabled');
      }
      updateCartPageCart(cartItem.dataset.lineItemKey, value);
    });

    removeButton.addEventListener('click', (event) => {
      removeButton.classList.add('text--loading');
      cartItem.classList.add('cart-page__item--removing');
      updateCartPageCart(cartItem.dataset.lineItemKey, 0);
    });

    cartItem.classList.add('cart-page--initialized');
  });

  initProductSwiperElements();
}

if (document.readyState !== 'loading') {
  initCartPage();
} else {
  window.addEventListener('DOMContentLoaded', initCartPage);
}
